<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.module_association_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_one_or_many_modules') }}: *</label
          >
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.modules', modules)"
            clearable
            multiple
            class="select-primary custom-width-select bus-rels shadow-sm required-modules"
            v-model="model.modules"
            filterable
            :placeholder="$t('common_words.select_one_or_many_modules2')"
          >
            <el-option
              v-for="option in modules"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.id} - ${option.name}`.replace(/^0 - /, '')"
              :key="option.id + ' - ' + option.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        modules: [],
      },
      modules: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.modules = this.concatAll(this.modules.splice(1));
    },
    validate() {
      if (!isset(this.model.modules)) {
        return this.validationInputsRequired('modules');
      } else {
        return this.$validator.validateAll().then((res) => {
          this.$emit('on-validated', res, this.model);

          let others = [];
          this.modules.forEach((item) => {
            this.model.modules.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          this.$emit('fillRoleForm', 'secondStep', {
            name_modules: others,
          });
          return res;
        });
      }
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('modules/indexfield')
        .then((response) => {
          this.modules = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
          this.showHideLoading();
        });
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.modules = [];
      editForm.modules_ids.forEach((item) => {
        this.model.modules.push(item);
      });
    }
  },
};
</script>
<style></style>
